/**
 * Store information pages (legal texts, guides, help): plain data rendered by InfoPage.
 * In paragraphs, "{email}" becomes the contact email link, "{whatsapp}" the WhatsApp number (the
 * paragraph is dropped when there is none), https:// URLs become links and "[[/path|label]]" an
 * internal link. Paragraphs starting with "{if:free}" / "{if:nofree}" only show while free shipping
 * is on / off (setting free_shipping_enabled), "{freeMin}" is its threshold in pesos, "{freeZones}" the zones it covers, and
 * "{rate:caba|cordon1|cordon2|cordon3}" the shipping price of that zone (setting shipping_rates_ars).
 */
import type { Locale } from "../../../shared/types";

export interface InfoSection {
  title: string;
  paragraphs: string[];
}

export interface InfoText {
  title: string;
  intro: string;
  sections: InfoSection[];
}

export type InfoDoc = Record<Locale, InfoText>;

/** "Last updated" date shown on the legal pages (ISO). Bump it whenever a legal text changes. */
export const LEGAL_UPDATED = "2026-10-26";

/** Used when the contact_email setting is empty. */
export const DEFAULT_CONTACT_EMAIL = "contacto@pokefans.fun";

/** Argentina's online consumer complaints form (Res. SCI 38/2017 asks shops to link it). */
export const CONSUMER_URL = "https://www.argentina.gob.ar/produccion/defensadelconsumidor/formulario";
